module.exports = __webpack_public_path__ + "payment-invoices-icon.png?04cabd65484f84c72e6fe42e87e1535a";